module.exports = __webpack_public_path__ + "img/c00_buildingtechhorseshoes_Normal_ua.423deff3.webp";